import React from 'react'
import { useSelector } from 'react-redux'
import Box from 'src/components/Box/Box'
import TextInputField, {
  TextInputFieldDesigns,
} from 'src/components/TextInputField/TextInputField'
import Trns, { translateSingleString } from 'src/localization/Trns'
import { selectNullSafeLocaleFromState } from 'src/redux/selectors/auth.selectors'
import { FormProps } from 'src/types'
import { css } from 'styled-components'

interface VendorNameInputBoxProps {
  id?: string
  className?: string
  vendorNameProps: FormProps<string>
  vendorNameFieldLabel: React.ReactElement
  tooltip?: React.ReactElement
  bottomElement?: React.ReactElement
  static?: boolean
  staticEmail?: string
}

const BillPayVendorNameInputBox: React.FC<VendorNameInputBoxProps> = (
  props,
): React.ReactElement => {
  const locale = useSelector(selectNullSafeLocaleFromState)

  return (
    <Box
      className={props.className}
      css={css`
        display: flex;
        flex-direction: column;
        gap: 24px;
      `}
    >
      <TextInputField
        id={props.id}
        fieldLabel={<Trns source={'Vendor Name'} />}
        showUpdates={props.vendorNameProps.showUpdates}
        value={props.vendorNameProps.value}
        baseValue={props.vendorNameProps.baseValue}
        errors={props.vendorNameProps.errors}
        onChange={props.vendorNameProps.onChange}
        placeholder={
          props.vendorNameProps.placeHolder ??
          translateSingleString(locale, 'Type here')
        }
        design={TextInputFieldDesigns.New}
        isStatic={props.static}
        characterLimit={255}
        hideCharacterLimitCount
      />
      {props.static && props.staticEmail !== undefined && (
        <TextInputField
          id={'vendorEmailTextInputField'}
          fieldLabel={<Trns source={'Vendor Email'} />}
          value={props.staticEmail}
          placeholder={''}
          design={TextInputFieldDesigns.New}
          isStatic={true}
        />
      )}
    </Box>
  )
}

export default BillPayVendorNameInputBox
